import { styled } from '@acko-tech/building-blocks.ui.common';

export const RootWrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Container = styled.div`
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
        #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Wrapper = styled.div`
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ErrorMessage = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #414a53;
    margin-bottom: 20px;
    white-space: pre-wrap;
`;

export const ButtonWrapper = styled.div`
    margin-top: 20px;
`;
